import Detail, {loader} from "./detail";

export {loader};
export default Detail;